import { mobileFormFieldsTypes } from '../../../config/constants/mobileFormConstant';
import ListComponent from '../componentsMobileForm/ListComponent';
import RadioComponent from '../componentsMobileForm/RadioComponent';
import TextAreaComponent from '../componentsMobileForm/TextAreaComponent';
import TextComponent from '../componentsMobileForm/TextComponent';
import AssetComponent from '../componentsMobileForm/AssetComponent';
import CheckboxComponent from '../componentsMobileForm/CheckboxComponent';
import CheckboxGroupComponent from '../componentsMobileForm/CheckboxGroupComponent';
import HeaderComponent from '../componentsMobileForm/HeaderComponent';
import { LoopComponent } from '../componentsMobileForm/LoopComponent';
import { ImagesComponent } from '../componentsMobileForm/ImagesComponent';
import { LocationDateComponent } from '../componentsMobileForm/LocationDateComponent';
import { NotSupportedField } from '../componentsMobileForm/NotSupportedField';

export const fieldComponents = {
  [mobileFormFieldsTypes.text.id]: { component: TextComponent },
  [mobileFormFieldsTypes.textArea.id]: { component: TextAreaComponent },
  [mobileFormFieldsTypes.radios.id]: { component: RadioComponent },
  [mobileFormFieldsTypes.list.id]: { component: ListComponent },
  [mobileFormFieldsTypes.header.id]: { component: HeaderComponent, nonInput: true },
  [mobileFormFieldsTypes.checkbox.id]: { component: CheckboxComponent, hideLabel: true },
  [mobileFormFieldsTypes.checkboxGroup.id]: { component: CheckboxGroupComponent },
  [mobileFormFieldsTypes.asset.id]: { component: AssetComponent },
  [mobileFormFieldsTypes.imgList.id]: { component: ImagesComponent },
  [mobileFormFieldsTypes.loop.id]: { component: LoopComponent },
  [mobileFormFieldsTypes.whitespace.id]: { component: () => <br />, nonInput: true },
  default: { component: NotSupportedField },
};

export const actionInputs = {
  [mobileFormFieldsTypes.locationDate.typeAction]: { component: LocationDateComponent, hideLabel: true },
  default: { component: NotSupportedField },
};

export const getContainerTitle = (label, index, tranlsate) => label?.trim() || `${tranlsate('container')} ${index + 1}`;
